import { render } from "./MdlNuevaPartida.vue?vue&type=template&id=3b89b808&scoped=true"
import script from "./MdlNuevaPartida.vue?vue&type=script&lang=js"
export * from "./MdlNuevaPartida.vue?vue&type=script&lang=js"

import "./MdlNuevaPartida.vue?vue&type=style&index=0&id=3b89b808&scoped=true&lang=css"

import exportComponent from "/var/www/adm3.argusblack/adm3.argusblack/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3b89b808"]])

export default __exports__